import { Table } from "../ui/Table";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getTeamActivityData } from "../../services/api";
import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { formatDate } from "../../helpers/util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { PaginationComponent } from "../ui/Pagination";
import { baseQueryAPI } from "../../services/baseQuery";

interface TeamActivity {
  name: string;
  first_name: string;
  last_name: string;
  activity_details: string;
  listing_name: string;
  address: string;
  public_id: string;
  time_added: number;
  listing_unique_id: string;
}

export const MyTeamActivity = () => {
  const [teamActivity, setTeamActivity] = useState<TeamActivity[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const logged = useSelector((state: any) => state.listingReducer.logged);

  const { data: teamActivityData } = baseQueryAPI.useTeamActivityQuery({
    currentPage: currentPage + 1,
  });

  useEffect(() => {
    if (teamActivityData) {
      setTeamActivity(teamActivityData.data);
      setTotalItems(teamActivityData.total || teamActivityData.data.length);
    }
  }, [teamActivityData]);

  const columnHelper = createColumnHelper<TeamActivity>();

  const columns = useMemo(
    () => [
      columnHelper.accessor("name", {
        cell: (info) => info.getValue(),
        header: "Member",
      }),
      columnHelper.display({
        header: "Activity",
        cell: (info) => (
          <>
            <span className="font-semibold capitalize">
              {info.row.original.activity_details.trim()}
            </span>{" "}
            {info.row.original.listing_name !== "Not available"
              ? info.row.original.listing_name
              : info.row.original.address}
          </>
        ),
      }),
      columnHelper.accessor("time_added", {
        cell: (info) => formatDate(info.getValue()),
        header: "Date",
      }),
      columnHelper.display({
        id: "action",
        cell(props) {
          return (
            <Link
              to={`/${props.row.original.listing_unique_id}`}
              className="text-primary"
            >
              View
            </Link>
          );
        },
      }),
    ],
    [columnHelper]
  );

  const table = useReactTable({
    columns,
    data: teamActivity,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="w-full p-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-gray-900">
          My Team Activity
        </h3>
        <button onClick={() => navigate("/")} className="h-10 w-10">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      <div className="mt-6">
        <input
          type="text"
          name="search"
          id="invite"
          placeholder="Search"
          className="border px-4 py-3 w-full"
        />

        <div className="mt-5">
          <Table heading={table.getHeaderGroups()} body={table.getRowModel()} />
        </div>

        <div>
          <PaginationComponent
            currentPage={currentPage}
            totalPages={Math.ceil(totalItems / 10)}
            setCurrentPage={(page) => setCurrentPage(page)}
          />
        </div>
      </div>
    </div>
  );
};
